import React from "react";
import { Input } from "antd";

const TextArea = (props) => {
  return <Input.TextArea size="large" autoSize={{ minRows: 4, maxRows: 6 }} {...props} />;
};

export default TextArea;
